<template>
    <div  class="meeting_des">
        <div v-html="meetingDes"></div>
    </div>
</template>
<script>

export default ({
    props:['meetingDes']
})
</script>
<style scoped lang="scss">
  
</style>



// WEBPACK FOOTER //
// src/components/Meeting/Introduction.vue